import { IApplicationState } from '../../types/redux';

export const selectActivePin = (state: IApplicationState) => state.map.activePin;
